import React, { useState, useEffect } from 'react';
import { DateRangePicker } from 'react-date-range';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField, FormControl, InputLabel, InputAdornment } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { subDays, subYears, startOfMonth, endOfMonth } from 'date-fns';
import { format } from 'date-fns'; // Import format from date-fns
import 'react-date-range/dist/styles.css'; // Default styles
import 'react-date-range/dist/theme/default.css'; // Default theme


export default function CustomDateRangePicker({ onDateChange }) {
  const [range, setRange] = useState([
    {
      startDate: subYears(new Date(), 4),
      endDate: new Date(),
      key: 'selection',
    },
  ]);

  const [open, setOpen] = useState(false); // State to manage the modal visibility
  const [selectedText, setSelectedText] = useState(() => {
    const formattedStartDate = format(subYears(new Date(), 4), 'dd MMMM yyyy');
    const formattedEndDate = format(new Date(), 'dd MMMM yyyy');
    return `${formattedStartDate} - ${formattedEndDate}`;
  });

  // const handleShortcut = (type) => {
  //   const today = new Date();
  //   let startDate, endDate;

  //   switch (type) {
  //     case 'today':
  //       startDate = endDate = today;
  //       break;
  //     case 'last7':
  //       startDate = subDays(today, 7);
  //       endDate = today;
  //       break;
  //     case 'last30':
  //       startDate = subDays(today, 30);
  //       endDate = today;
  //       break;
  //     case 'thisMonth':
  //       startDate = startOfMonth(today);
  //       endDate = today;
  //       break;
  //     case 'lastMonth':
  //       startDate = startOfMonth(subDays(today, 30));
  //       endDate = endOfMonth(subDays(today, 30));
  //       break;
  //     default:
  //       startDate = new Date();
  //       endDate = new Date();
  //   }

  //   setRange([{ startDate, endDate, key: 'selection' }]);
  // };

  // Handle opening and closing of the modal
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // Handle date selection from DateRangePicker (without updating the state yet)
  const handleSelect = (item) => {
    setRange([item.selection]);

    // Format the start and end dates as "dd MMMM yyyy"
    const formattedStartDate = format(item.selection.startDate, 'dd MMMM yyyy');
    const formattedEndDate = format(item.selection.endDate, 'dd MMMM yyyy');

    setSelectedText(`${formattedStartDate} - ${formattedEndDate}`);
  };

  // Handle the "Submit" button click
  const handleSubmit = () => {
    const { startDate, endDate } = range[0];

    // Ensure that the dates are formatted correctly
    const formattedStartDate = format(startDate, 'yyyy-MM-dd');
    const formattedEndDate = format(endDate, 'yyyy-MM-dd');

    console.log("Formatted Start Date:", formattedStartDate);  // Check the formatted values
    console.log("Formatted End Date:", formattedEndDate);

    // Call the onDateChange function with formatted dates
    if (onDateChange) {
      onDateChange({ startDate: formattedStartDate, endDate: formattedEndDate });
    }

    handleClose();
  };


  return (
    <Box sx={{ width: '100%', padding: 2, marginTop: 2 }}>
      {/* FormControl wrapper for TextField */}
      <FormControl fullWidth variant="filled">
        <InputLabel
          htmlFor="date-range-picker"
          shrink={selectedText.length > 0} // Ensure label shrinks when there's a value
          sx={{
            position: 'absolute',
            left: 15,
            bottom: 8,
            transition: 'transform 0.2s ease', // Smooth transition when floating
            transform: selectedText.length > 0 ? 'translateY(-20px)' : 'translateY(50%)', // Adjusted position of the label
            transformOrigin: 'top left',
            pointerEvents: 'none', // Disable mouse interactions with label
          }}
        >
          Pilih Tanggal
        </InputLabel>
        <TextField
          id="date-range-picker"
          size="small"
          color='secondary'
          value={selectedText} // Updated value of the TextField
          onClick={handleOpen}
          variant="outlined"
          fullWidth
          sx={{
            '& .MuiInputBase-root': {
              fontSize: '0.95rem', // Smaller font size
            },
            '& .MuiOutlinedInput-root': {
              fontSize: '0.77rem', // Adjust the font size in the OutlinedInput
            },
          }}
          slotProps={{
            textField: {
              InputProps: {
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleOpen}
                      aria-label="open calendar"
                      sx={{
                        padding: '4px',
                        fontSize: '16px', // Icon size adjustment
                      }}
                    >
                      <CalendarTodayIcon sx={{ fontSize: 'inherit' }} />
                    </IconButton>
                  </InputAdornment>
                ),
              },
            },
          }}
        />
      </FormControl>

      {/* Dialog to show DateRangePicker */}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        sx={{
          '& .MuiDialogContent-root': {
            padding: '16px 24px', // Padding for content inside the dialog
          },
          '& .MuiDialog-paper': {
            width: 'auto', // Make the dialog width auto to fit the content
            maxWidth: '600px', // Set a maximum width for the dialog
          },
        }}
      >
        <DialogTitle>Pilih Tanggal</DialogTitle>
        <DialogContent>
          <DateRangePicker
            ranges={range}
            onChange={handleSelect}
            editableDateInputs
            moveRangeOnFirstSelection={false}
            className="custom-datepicker"
            style={{ display: 'block' }}  // Applying inline styles
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSubmit} color="primary">
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* Shortcut Buttons */}
    </Box>
  );
}